import './App.scss';
import {ThemeProvider} from "@mui/material";
import greenTheme from "./components/themes/GreenTheme";

import {ConfigProvider} from "./context/ConfigContext";
import {ErrorProvider} from "./context/ErrorContext";
import {LocalizationProvider} from "@mui/x-date-pickers";
import locale from "date-fns/locale/hu";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {AuthProvider} from "./context/AuthContext";
import AppRoutes from "./routes/routes";
import {BrowserRouter} from "react-router";
import ScrollToTop from "./components/utils/ScrollToTop";

function App() {

    return <ThemeProvider theme={greenTheme}>
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={locale}>
            <ConfigProvider>
                <ErrorProvider>
                    <BrowserRouter>
                        <AuthProvider>
                            <ScrollToTop/>
                            <AppRoutes/>
                        </AuthProvider>
                    </BrowserRouter>
                </ErrorProvider>
            </ConfigProvider>
        </LocalizationProvider>
    </ThemeProvider>
}

export default App;